export default __webpack_public_path__ + "static/media/component_template.f21ce82d.xlsx";